import { render } from "./AddressCategoryFormModal.vue?vue&type=template&id=4cfe29e5&scoped=true"
import script from "./AddressCategoryFormModal.vue?vue&type=script&lang=js"
export * from "./AddressCategoryFormModal.vue?vue&type=script&lang=js"

import "./AddressCategoryFormModal.vue?vue&type=style&index=0&id=4cfe29e5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfe29e5"]])

export default __exports__